import React from 'react';
import Button from '../buttons/button12';

/**
 * ImageCard - A reusable card component with an image, title, description, and buttons
 * 
 * @param {Object} props
 * @param {string} props.title - Card title
 * @param {string} props.description - Card description
 * @param {string|Object} props.image - Image source or object with src and alt properties
 * @param {boolean} props.showPrimaryButton - Whether to show the primary button
 * @param {boolean} props.showSecondaryButton - Whether to show the secondary button
 * @param {string} props.primaryButtonText - Text for primary button
 * @param {string} props.secondaryButtonText - Text for secondary button
 * @param {function} props.onPrimaryClick - Callback for primary button click
 * @param {function} props.onSecondaryClick - Callback for secondary button click
 * @param {React.ReactNode} props.swapComponent - Component to render in the swap area
 * @param {string} props.swapLabel - Label for swap component
 * @param {string} props.width - Width of the card (default: w-96)
 */
const ImageCard = ({
  title = "Title",
  description = "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.",
  image = "/api/placeholder/400/240",
  showPrimaryButton = true,
  showSecondaryButton = true,
  primaryButtonText = "Primary",
  secondaryButtonText = "Secondary",
  onPrimaryClick = () => { },
  onSecondaryClick = () => { },
  swapComponent = null,
  swapLabel = "Swap component",
  width = "w-96"
}) => {
  // Handle image source formatting
  const imgSrc = typeof image === 'string' ? image : image.src;
  const imgAlt = typeof image === 'string' ? 'Card image' : (image.alt || 'Card image');

  // Determine if we should show the button container at all
  const showAnyButtons = showPrimaryButton || showSecondaryButton;

  return (
    <div className={`${width} bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-200 inline-flex flex-col justify-start items-start`}>
      {/* Image section */}
      <div className="self-stretch rounded-tl-xl rounded-tr-xl h-48 overflow-hidden">
        <img
          src={imgSrc}
          alt={imgAlt}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content section */}
      <div className="self-stretch p-6 flex flex-col justify-start items-start gap-6">
        <div className="self-stretch flex flex-col justify-start items-start gap-2">
          <div className="self-stretch flex flex-col justify-start items-start gap-2">
            <div className="self-stretch flex flex-col justify-start items-start gap-1">
              {/* Swap component area */}
              {swapComponent && (
                <div className="self-stretch inline-flex justify-start items-start gap-3">
                  {swapComponent} {/* Render the actual component passed as swapComponent */}
                </div>
              )}

              {/* Title */}
              <div className="self-stretch justify-start text-neutral-900 text-2xl font-bold font-['Arial'] capitalize leading-9">
                {title}
              </div>
            </div>
            {/* Description */}
            <div className="self-stretch justify-start text-neutral-900 text-sm font-normal font-['Arial'] leading-normal">
              {description}
            </div>
          </div>
        </div>

        {/* Buttons */}
        {showAnyButtons && (
          <div className="self-stretch inline-flex justify-start items-start gap-2">
            {/* Primary button */}
            {showPrimaryButton && (
              <div className="flex justify-start items-start">
                <button
                  onClick={onPrimaryClick}
                  className="px-6 py-3 bg-blue-600 rounded-lg flex justify-center items-center gap-2"
                >
                  <div className="text-center justify-start text-white text-base font-normal font-['Arial'] leading-normal">
                    {primaryButtonText}
                  </div>
                </button>
              </div>
            )}

            {/* Secondary button */}
            {showSecondaryButton && (
              // <div className="flex justify-start items-start">
              //   <button
              //     onClick={onSecondaryClick}
              //     className="px-6 py-3 rounded-lg outline outline-1 outline-offset-[-1px] outline-blue-600 flex justify-center items-center gap-2"
              //   >
              //     <div className="text-center justify-start text-blue-600 text-base font-normal font-['Arial'] leading-normal">
              //       {secondaryButtonText}
              //     </div>
              //   </button>
                <Button
                text={secondaryButtonText}
                state="Default"
                type="Secondary"
                variant="Default"
                onClick={onSecondaryClick}
                className=""
              />
              // </div>

              
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageCard;